import { Button, Grid } from "@aws-amplify/ui-react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import LocalizedStrings from "react-localization";
import { API, graphqlOperation } from "aws-amplify";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";

import ItemListCollection from "../ItemListCollection";
import { devicesByCompanyID } from "graphql/queries";

export const DevicesChoose = ({
  initDevicesGranted = [],
  onChangeDevicesGranted,
  resetValues,
  company,
}) => {
  const [devicesAvailable, setDevicesAvailable] = useState([]);
  const [devicesGranted, setDevicesGranted] = useState([]);
  const [devicesAvailableSelected, setDevicesAvailableSelected] = useState([]);
  const [devicesGrantedSelected, setDevicesGrantedSelected] = useState([]);
  const [keywordDevicesGranted, setKeywordDevicesGranted] = useState("");

  async function fetchDevicesAvailable(keyword, diffDevices, companyID) {
    try {
      const devicesData = await API.graphql(
        graphqlOperation(devicesByCompanyID, {
          limit: !keyword ? 50 : undefined,
          filter: keyword
            ? {
                or: [
                  {
                    name: { contains: keyword },
                  },
                ],
              }
            : {},
          companyID,
        })
      );
      const devicesItems = devicesData.data.devicesByCompanyID.items;
      const devicesGrantedExist = devicesItems?.filter((deviceItem) =>
        diffDevices?.some((diffUs) => diffUs.id === deviceItem.id)
      );

      setDevicesGranted(devicesGrantedExist);
      setDevicesAvailable(
        devicesItems
          ?.filter(
            (deviceItem) =>
              !devicesGrantedExist?.some(
                (diffUs) => diffUs.id === deviceItem.id
              )
          )
          ?.map((deviceItem) => ({
            id: deviceItem.id,
            name: deviceItem.name,
          }))
      );
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    if (company) {
      fetchDevicesAvailable(undefined, initDevicesGranted, company);
    } else {
      setDevicesGranted([]);
      setDevicesAvailable([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initDevicesGranted, resetValues, company]);

  useEffect(() => {
    if (onChangeDevicesGranted) onChangeDevicesGranted(devicesGranted);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [devicesGranted]);

  const cleanSelected = () => {
    setDevicesAvailableSelected([]);
    setDevicesGrantedSelected([]);
  };

  const setInAvailable = (items) => {
    setDevicesAvailable((prevSt) => [...prevSt, ...items]);
    setDevicesGranted((prevSt) =>
      prevSt.filter((prev) => !items?.some((device) => device.id === prev.id))
    );
    cleanSelected();
  };

  const setInGranted = (items) => {
    setDevicesGranted((prevSt) => [...prevSt, ...items]);
    setDevicesAvailable((prevSt) =>
      prevSt.filter((prev) => !items?.some((device) => device.id === prev.id))
    );
    cleanSelected();
  };

  const onSearchDevicesGranted = (keyword) => {
    setKeywordDevicesGranted(keyword);
  };

  return (
    <Grid templateColumns={{ base: "1fr", large: "2fr 1fr 2fr" }} gap="30px">
      <div>
        <div className="fs-5 mb-3">{strings.devices.available}</div>
        <ItemListCollection
          items={devicesAvailable}
          selectedItems={devicesAvailableSelected}
          setSelectedItems={setDevicesAvailableSelected}
          onSearchSubmit={(keyword) =>
            fetchDevicesAvailable(keyword, devicesGranted, company)
          }
        />
      </div>
      <div style={styles.containerButtons}>
        <Button
          style={styles.buttonActions}
          onClick={() => setInAvailable(devicesGrantedSelected)}
        >
          <IoIosArrowBack />
        </Button>
        <Button
          style={styles.buttonActions}
          onClick={() => setInAvailable(devicesGranted)}
        >
          <IoIosArrowBack />
          <IoIosArrowBack />
        </Button>
        <Button
          style={styles.buttonActions}
          onClick={() => setInGranted(devicesAvailableSelected)}
        >
          <IoIosArrowForward />
        </Button>
        <Button
          style={styles.buttonActions}
          onClick={() => setInGranted(devicesAvailable)}
        >
          <IoIosArrowForward />
          <IoIosArrowForward />
        </Button>
      </div>
      <div>
        <div className="fs-5 mb-3">{strings.devices.granted}</div>
        <ItemListCollection
          items={
            keywordDevicesGranted
              ? devicesGranted.filter((deviceGr) =>
                  deviceGr.name
                    .toLowerCase()
                    .includes(keywordDevicesGranted?.toLowerCase())
                )
              : devicesGranted
          }
          selectedItems={devicesGrantedSelected}
          setSelectedItems={setDevicesGrantedSelected}
          onSearchSubmit={onSearchDevicesGranted}
        />
      </div>
    </Grid>
  );
};

const strings = new LocalizedStrings({
  es: {
    devices: {
      available: "Dispositivos disponibles",
      granted: "Dispositivos asociados",
    },
    responses: {
      errorFetch: "Error al consultar dispositivos",
    },
  },
});

const styles = {
  containerButtons: {
    display: "flex",
    justifyContent: "center",
    flexFlow: "column",
    gap: "10px",
  },
  buttonActions: {
    width: "65px",
    alignSelf: "center",
  },
};

export default DevicesChoose;
